import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  AwardAmounts,
  ScholarshipRenewal,
  UserCollege,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import type { LetterChecks } from './awardLetter.util';

type AwardLetterAgentContext = Readonly<{
  college: UserCollege;
  amounts: AwardAmounts;
  renewal: ScholarshipRenewal | null;
  netCost: number | null;
  letterChecks: LetterChecks | null;
}>;

export const useAgentContext = ({
  college,
  amounts,
  renewal,
  netCost,
  letterChecks,
}: AwardLetterAgentContext) => {
  useRegisterAgentContext({
    kind: 'form',
    description: `The student's financial aid award letter for ${college.name}. Every change saves as they make it: uploading a letter reads and saves its numbers, the edit dialog saves the five amounts, and the renewal answer saves when picked. Amounts are whole dollars per year; null means blank. Net cost is cost of attendance minus grants and scholarships; loans and work-study don't lower it. estimated_net_cost is the College Scorecard estimate for families at their income, or the college's average net price when there is none, which the page compares the letter against. letter_checks is what Backrs read from the letter they just uploaded (null when no letter was read on this visit). Once a letter file is uploaded, a Check with Lubav list offers questions Lubav answers by reading the letter: whether loans are listed separately, whether a Parent PLUS loan counts as aid, the cost of attendance, and, when the letter has scholarships, what it takes to keep them.`,
    data: {
      college: college.name,
      ...amounts,
      scholarships_renewable: renewal,
      net_cost: netCost,
      estimated_net_cost: college.estimated_net_cost,
      letter_checks: letterChecks,
    },
  });
};
